var m = typeof window > "u" || "Deno" in globalThis;
function O() {
}
function k(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function q(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function F(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function b(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function w(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function K(e, t) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: f
  } = e;
  if (s) {
    if (n) {
      if (t.queryHash !== j(s, t.options))
        return !1;
    } else if (!p(t.queryKey, s))
      return !1;
  }
  if (r !== "all") {
    const c = t.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof f == "boolean" && t.isStale() !== f || i && i !== t.state.fetchStatus || o && !o(t));
}
function P(e, t) {
  const { exact: r, status: n, predicate: i, mutationKey: o } = e;
  if (o) {
    if (!t.options.mutationKey)
      return !1;
    if (r) {
      if (a(t.options.mutationKey) !== a(o))
        return !1;
    } else if (!p(t.options.mutationKey, o))
      return !1;
  }
  return !(n && t.state.status !== n || i && !i(t));
}
function j(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || a)(e);
}
function a(e) {
  return JSON.stringify(
    e,
    (t, r) => h(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r
  );
}
function p(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? Object.keys(t).every((r) => p(e[r], t[r])) : !1;
}
function y(e, t) {
  if (e === t)
    return e;
  const r = d(e) && d(t);
  if (r || h(e) && h(t)) {
    const n = r ? e : Object.keys(e), i = n.length, o = r ? t : Object.keys(t), s = o.length, f = r ? [] : {};
    let c = 0;
    for (let l = 0; l < s; l++) {
      const u = r ? l : o[l];
      (!r && n.includes(u) || r) && e[u] === void 0 && t[u] === void 0 ? (f[u] = void 0, c++) : (f[u] = y(e[u], t[u]), f[u] === e[u] && e[u] !== void 0 && c++);
    }
    return i === s && c === i ? e : f;
  }
  return t;
}
function v(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function d(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function h(e) {
  if (!g(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(!g(r) || !r.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function g(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function T(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function E(e, t, r) {
  if (typeof r.structuralSharing == "function")
    return r.structuralSharing(e, t);
  if (r.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return y(e, t);
      } catch (n) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${r.queryHash}]: ${n}`
        ), n;
      }
    return y(e, t);
  }
  return t;
}
function N(e, t, r = 0) {
  const n = [...e, t];
  return r && n.length > r ? n.slice(1) : n;
}
function A(e, t, r = 0) {
  const n = [t, ...e];
  return r && n.length > r ? n.slice(0, -1) : n;
}
var S = Symbol();
function I(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === S && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === S ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function H(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
export {
  N as addToEnd,
  A as addToStart,
  I as ensureQueryFn,
  k as functionalUpdate,
  a as hashKey,
  j as hashQueryKeyByOptions,
  d as isPlainArray,
  h as isPlainObject,
  m as isServer,
  q as isValidTimeout,
  P as matchMutation,
  K as matchQuery,
  O as noop,
  p as partialMatchKey,
  E as replaceData,
  y as replaceEqualDeep,
  w as resolveEnabled,
  b as resolveStaleTime,
  v as shallowEqualObjects,
  H as shouldThrowError,
  S as skipToken,
  T as sleep,
  F as timeUntilStale
};
//# sourceMappingURL=contact-channels116.js.map
